import { guardNumber } from "@msuite/utils/numbers";
import { motion } from "motion/react";
import type Supercluster from "supercluster";
import { cn } from "../utils";

/** Props Interface */
interface MapViewClusterMarkerProps {
	cluster?:
		| Supercluster.PointFeature<Supercluster.AnyProps>
		| Supercluster.ClusterFeature<Supercluster.AnyProps>;
}

export function MapViewClusterMarker({ cluster }: MapViewClusterMarkerProps) {
	/** Computed */
	const count = guardNumber(cluster?.properties.point_count ?? 0);

	/** Scale */
	const scale = Math.min(0.5 + count / 4, 3.5);

	/** Render */
	return (
		<motion.div
			style={{ scale }}
			className={cn(
				"card flex-center rounded-xl",
				"border-2 border-primary-200",
				"*:text-white! bg-indigo-600",
			)}
		>
			<p className="tabular-nums">{count}</p>
		</motion.div>
	);
}
